// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"1d9cc805","977":"bd9f1384"}[chunkId] + ".chunk.js";
};